module.exports = "/lucky-balls/img/infobox/info_Box_007.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_007.png
// module id = 1072
// module chunks = 0